import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function AdminQuotes() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api
      .get("/quotes")
      .then((r) => setItems(r.data || []))
      .catch(() => toast.error("Failed to load quotes."))
      .finally(() => setLoading(false));
  }, []);
  return (
    <div data-testid="admin-quotes">
      <div className="font-mono-accent text-[10px] uppercase text-[#4A5550]">◆ Quote Submissions</div>
      <h1 className="font-display font-black uppercase tracking-tighter text-3xl md:text-5xl mb-8 mt-1">
        Quotes ({items.length})
      </h1>
      {loading ? (
        <div className="font-mono-accent text-sm">Loading…</div>
      ) : items.length === 0 ? (
        <div className="border-2 border-[#122A1E] bg-[#EAEAE5] p-8 text-center text-[#4A5550]">
          No quote submissions yet.
        </div>
      ) : (
        <div className="grid gap-4">
          {items.map((q) => (
            <article key={q.id} className="border-2 border-[#122A1E] bg-[#F4F4F1] p-6" data-testid={`quote-${q.id}`}>
              <div className="flex flex-wrap items-baseline justify-between gap-3 mb-3">
                <div>
                  <div className="font-display font-black uppercase">{q.full_name}</div>
                  <div className="font-mono-accent text-[10px] uppercase text-[#4A5550]">
                    {new Date(q.created_at).toLocaleString("en-CA")}
                  </div>
                </div>
                <span className="font-mono-accent text-[10px] uppercase bg-[#FF5A00] text-white px-2 py-1">
                  {q.vehicle_type}
                </span>
              </div>
              <div className="grid md:grid-cols-2 gap-3 text-sm">
                <div>
                  <span className="font-mono-accent text-[10px] uppercase text-[#4A5550]">Pickup</span>
                  <div>{q.pickup_city}, {q.pickup_province}</div>
                </div>
                <div>
                  <span className="font-mono-accent text-[10px] uppercase text-[#4A5550]">Delivery</span>
                  <div>{q.delivery_city}, {q.delivery_province}</div>
                </div>
                <div><a className="text-[#FF5A00] underline" href={`mailto:${q.email}`}>{q.email}</a></div>
                <div><a className="text-[#FF5A00] underline" href={`tel:${q.phone}`}>{q.phone}</a></div>
              </div>
              {q.vehicle_details && <p className="mt-3 text-sm text-[#4A5550]"><strong>Details:</strong> {q.vehicle_details}</p>}
              {q.message && <p className="mt-2 text-sm text-[#4A5550]"><strong>Notes:</strong> {q.message}</p>}
              {q.preferred_date && <p className="mt-2 text-sm text-[#4A5550]"><strong>Preferred:</strong> {q.preferred_date}</p>}
              {q.utm_source && (
                <div className="mt-3 pt-3 border-t-2 border-[#D2CEBD] text-xs">
                  <div className="font-mono-accent text-[10px] uppercase text-[#FF5A00] mb-1">◆ Attribution</div>
                  <div className="font-mono-accent text-[10px] text-[#4A5550] flex flex-wrap gap-x-3">
                    {q.utm_source && <span>src: <strong>{q.utm_source}</strong></span>}
                    {q.utm_medium && <span>med: <strong>{q.utm_medium}</strong></span>}
                    {q.utm_campaign && <span>camp: <strong>{q.utm_campaign}</strong></span>}
                    {q.utm_term && <span>term: <strong>{q.utm_term}</strong></span>}
                    {q.gclid && <span>gclid: <strong>{q.gclid.slice(0, 20)}…</strong></span>}
                  </div>
                </div>
              )}
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
